export default __webpack_public_path__ + "static/media/git.7b9528d8.svg";